import * as Utilities from 'lib/utilities';

// Lib
import DetectTouchDevice from 'lib/detect-touch-device';
import DetectBreakpoints from 'lib/detect-breakpoints';
import LazySvgs from 'lib/lazy-svgs';
import ToggleClass from 'lib/toggle-class';

// Init App->Lib
import init_object_fit_polyfill from 'app/init-app/init-object-fit-polyfill';
import init_internet_explorer from 'app/init-app/init-internet-explorer';
import init_scroll_animations from 'app/init-app/init-scroll-animations';
import init_detect_touch_device from 'app/init-app/init-detect-touch-device';
import init_misc from 'app/init-app/init-misc';
import init_webfonts from 'app/init-app/init-webfonts';
import init_map from 'app/init-app/init-map';
import init_gallery_modal from 'app/init-app/init-gallery-modal';
import init_sevenrooms from 'app/init-app/init-sevenrooms';
// import init_booking_modal from 'app/init-app/init-booking-modal';

// Init Modules
const toggleClass = ToggleClass();
const detectTouchDevice = DetectTouchDevice();
const breakpoints = DetectBreakpoints();
const lazySvgs = LazySvgs();

const app = {
    toggleClass,
    detectTouchDevice,
    breakpoints,
    lazySvgs
};

init_object_fit_polyfill();
init_internet_explorer();
init_scroll_animations(app);
init_detect_touch_device(app);
//init_webfonts();
init_misc(app);
init_map();
init_gallery_modal();
init_sevenrooms();
// init_booking_modal();

window.Utilities = Utilities;
window.app = app;

function resize_all() {
    app.scrollAnimations.resize();
}

window.addEventListener('load', resize_all);
